import React, { useEffect } from 'react';
import {
    Box,
    Grid,
    makeStyles,
} from '@material-ui/core';

import {
    Typography,
    useMediaQuery
} from '@material-ui/core';

import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes'

import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useTranslate } from 'react-admin';
import CustomProgress from '../CustomizedUIs/CustomProgessbar'

const useStyles = makeStyles(theme => ({
    reportItem: {
        borderBottomColor: '#f3f7fa',
        paddingTop: 4,
        paddingBottom: 4,
    },
    reportItemNumber: {
        // borderRadius: '0.25rem',
        margin: '0.25rem 0.5rem',
        borderRadius: '7px',
        border: 'solid 0.7px #e0f0f2',
        backgroundColor: ' #fafefe',
        width: '20px',
        height: '20px',
    },
    Title: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
      
    }, TitleUsage: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
        paddingTop: '15px',
    },
    borderTable: {
        borderRadius: ' 4px',
        border: ' solid 1px #e0f0f2',
        backgroundColor: '#ffffff',
    },
    TitleTable: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    NumberTable: {
        textAlign: 'center',
        fontFamily: 'UniviaPro',
        fontSize: '9px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
        padding: '5px'
    },
    Usage: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '18px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.36px',
        color: '#88898c',
    },
    Usage1: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.36px',
        color: '#88898c',
    }
}));

const formatperent=(array)=>{
    var tempdiff=0
    var floarArray=array.map(item=>{
        item[1]=Math.floor(item[1])
        tempdiff+=item[1]
        return item
    })
    var diff=100-tempdiff
    floarArray.sort(function(a, b){return a[1]-b[1]})
    var obj={}
   return floarArray.forEach(item=>{
        if(diff>0){
            item[1]++
            diff--
        }
      obj[item[0]]=item[1]
    })


}

const RateItem = ({ name, rate, color, firstItem, lastItem }) => {
    const classes = useStyles();
    const [progress, setProgress] = React.useState(0);
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
    const theme = useSelector((state) => state.theme);
    // React.useEffect(() => {

    //     function tick() {
    //         setProgress(oldProgress => (oldProgress < rate ? oldProgress + 1 : oldProgress = rate));
    //     }
    //     var timer = setInterval(tick, 10)
    //     return () => {
    //         clearInterval(timer);
    //     };

    // }, []);
    return (
        <Grid item style={{ textAlign: 'center' }} >

            <Box
                style={{
                    marginTop: '1rem',
                    marginLeft: firstItem ? '0' : '1.4375rem',
                    marginRight: lastItem ? '0' : '1.4375rem',
                }}
            >
                <CustomProgress rate={rate || 0} color={color}></CustomProgress>
                <Typography className={classes.Title} style={{ marginTop: '1rem' }}>{name}</Typography>
            </Box>
        </Grid>
    )
}

const ReportItem = ({ name, quantity }) => {
    const classes = useStyles();

    return (
        <Box display='flex' alignItems='center' borderBottom={1} className={classes.reportItem}>
            <Box width={"80%"}>
                <Typography className={classes.Title}>{name}</Typography>
            </Box>
            <Box className={classes.reportItemNumber}
            >
                <Typography className={classes.NumberTable}>{quantity}</Typography>
            </Box>
        </Box>
    )
}

const RePortDashboard = ({ data, tvUsage }) => {
    const classes = useStyles();
    const translate = useTranslate();
    const isXSmall = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));


    return (
        <Box display="flex" width={!isDesktop ? "95%" : "80%"} m='auto' >
            {
                !isXSmall && (
                    <Box width="80%">
                        <Box flexGrow={1} ml="5px">
                            <Typography className={classes.TitleUsage}>
                                {translate(`pos.dashboard.usageData`)}
                            </Typography>
                        </Box>
                        <Grid container direction="row">
                            <RateItem rate={tvUsage.tvmode} name={translate(`pos.dashboard.tv`)} color='#bbd593' firstItem={true}></RateItem>
                            <RateItem rate={tvUsage.offline} name={translate(`pos.dashboard.offline`)} color='#eb5a4d'></RateItem>
                            <RateItem rate={tvUsage.menumode} name={translate(`pos.dashboard.menu`)} color='#6cb5b8'></RateItem>
                            <RateItem rate={tvUsage.infochannel} name={translate(`pos.dashboard.infoChannel`)} color='#b21280' lastItem={true}></RateItem>
                        </Grid>
                    </Box>
                )
            }

            <Box className={classes.borderTable} style={{
                paddingLeft: '1rem',
                paddingRight: '1rem',
                paddingTop: '0.25rem',
                paddingBottom: 0
            }} width={isXSmall ? "100%" : "20%"} height="100%" border={1} borderColor="#e0f0f2" bgcolor='white' borderRadius="borderRadius">
                <Box>
                    <Typography className={classes.TitleTable}>
                        {translate(`pos.dashboard.clusterAndDevice`)}
                    </Typography>
                </Box>
                <Box width='100%' bgcolor='background.paper' borderRadius="borderRadius">
                    <ReportItem name={translate(`pos.dashboard.entitys`)} quantity={data.countResult.total.entities} />
                    <ReportItem name={translate(`pos.dashboard.groups`)} quantity={data.countResult.total.groups} />
                    <ReportItem name={translate(`pos.dashboard.clusters`)} quantity={data.countResult.total.clusters} />
                    <ReportItem name={translate(`pos.dashboard.rooms`)} quantity={data.countResult.total.rooms} />
                    <ReportItem name={translate(`pos.dashboard.devices`)} quantity={data.countResult.total.devices} />
                </Box>
            </Box>
        </Box>
    );
}

export {RateItem}
export default RePortDashboard

